import { get } from "@devforce/trailhead-client-env";
import type {
  LearningSummaryType,
  LearningFragmentType,
  LearningKindType,
} from "@devforce/trailhead-client-gql";

export type LearningKindUnionType = `${LearningKindType}`;

export type LearningKindCollectionType = Extract<
  LearningKindUnionType,
  | "BADGE"
  | "MODULE"
  | "PROJECT"
  | "SUPERBADGE"
  | "TRAIL"
  | "TRAILMIX"
  | "LEARNINGPATH"
>;

export type LearningType = LearningSummaryType | LearningFragmentType;

/**
 * Tell whether "badge" labels should be used instead of "module" and "project".
 * Workaround since our backend doesn't support badge type yet.
 * @returns true badge labels should be used, false otherwise.
 */
export function useBadgeLabels() {
  return get("USE_BADGE_LABELS");
}

export function pluralizeLearningCollectionType(
  type: LearningKindCollectionType
) {
  const badgeLabels = useBadgeLabels();
  switch (type) {
    case "BADGE":
      return "badges";
    case "MODULE":
      return badgeLabels ? "badges" : "modules";
    case "PROJECT":
      return badgeLabels ? "badges" : "projects";
    case "SUPERBADGE":
      return "superbadges";
    case "TRAIL":
    case "LEARNINGPATH":
      return "trails";
    case "TRAILMIX":
      return "trailmixes";
    default:
      return type;
  }
}

export type LearningCollectionItem = {
  name: string;
  type: LearningKindCollectionType;
};
